import React,{useRef,useState} from "react";
import '../../style_new.css';
import emailjs from "@emailjs/browser";
import Loader from "../Loader";

const SERVICE_ID = "service_gt2azly";
const TEMPLATE_ID = "template_zrcxke8";
const PUBLIC_KEY = "GTUWxDDlO2Nswdvjo";


const Appointment = () => {

    const formRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handelSubmit =async(e)=>{
   e.preventDefault();
    if (!formRef.current) return;

    const form = formRef.current;
    const formData = new FormData(form);
    
    const requiredFields = ["name", "email", "phone",  "message"];
    for (const field of requiredFields) {
      if (!formData.get(field)) {
        alert("Please fill in all fields.");
        return;
      }
    } 
    console.log({formData:formData.current})

    setIsSubmitting(true);

    try {
      await emailjs.sendForm(
        SERVICE_ID,
        TEMPLATE_ID,
        formRef.current,
        PUBLIC_KEY
      );
      alert("Message sent successfully!");
      form.reset();
    } catch (error) {
      alert("Something went wrong, please try again.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  }


  return (
    <>
      {/* appointment section start */}
      <div class="container-fluid appointment my-5 py-5 wow fadeIn" data-wow-delay="0.1s">
            <div class="container py-5">
              <div class="row g-5">
                <div class="col-lg-5 col-md-6 wow fadeIn" data-wow-delay="0.3s">
                  <div class="border-start border-5 border-primary ps-4 mb-5">
                    <h6 class="text-white text-uppercase mb-2">Appointment</h6>
                    <h1 class="display-6 text-white mb-0">
                      A Company Involved In Service And Maintenance
                    </h1>
                  </div>
                  <p class="text-white mb-0">
                      Book your appointment with confidence. We specialize in professional maintenance and reliable services that meet your needs. 
                      Our experienced team ensures quality care, fast response times, and tailored solutions. Whether routine or urgent, we're here to help. 
                      Contact us today and experience a commitment to excellence you can count on.

                  </p>
                </div>
                <div class="col-lg-7 col-md-6 wow fadeIn" data-wow-delay="0.5s">
                  <form ref={formRef} onSubmit={handelSubmit}>
                    <div class="row g-3">
                      <div class="col-sm-12">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control bg-dark border-0"
                            id="gname"
                            placeholder="Your name"
                            name="name"
                           required
                          />
                          <label for="gname">Your Name</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-floating">
                          <input
                            type="email"
                            class="form-control bg-dark border-0"
                            id="gmail"
                            placeholder="Your email address"
                             name="email"
                            required
                          />
                          <label for="gmail">Your Email</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-floating">
                          <input
                            type="number"
                            class="form-control bg-dark border-0"
                            id="cname"
                            placeholder="Your phone number"
                            name="phone"
                            required
                          />
                          <label for="cname">Your Mobile</label>
                        </div>
                      </div>
                      <input type="hidden" name="subject" value="Appointment" />
                      <div class="col-12">
                        <div class="form-floating">
                          <textarea
                            class="form-control bg-dark border-0"
                            placeholder="Leave a message here"
                            id="message"
                            style={{height: '100px'}}
                            name="message"
                          ></textarea>
                          <label for="message">Message</label>
                        </div>
                      </div>
                      {isSubmitting ? <Loader /> :  
                      <div class="col-12">
                        <button class="btn btn-primary w-100 py-3" type="submit">
                          Get Appointment
                        </button>
                      </div>
                      }
                     
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* appointment section end */}
    </>
  );
};
  
export default Appointment;